var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('p',{staticClass:"tech-header",attrs:{"data-cursor-hover":""}},[_vm._v(_vm._s(_vm.name)+":")]),_c('div',{staticClass:"mt-2"},_vm._l((_vm.technology),function(tech,index){return _c('img',{key:index,staticClass:"mr-1",attrs:{"src":tech,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }